import type { LaunchPadData } from '@mogul/api-client';
import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { CollectionCard } from '../marketplace/collectionCard/CollectionCard.component';
import styles from './LaunchPadList.module.css';
// import { NftCard } from './nft-card/NftCard.component';

interface LaunchPadListProps {
  launchpads?: LaunchPadData[];
}

export const LaunchPadList: FC<LaunchPadListProps> = ({
  launchpads,
}: LaunchPadListProps) => {
  const [_, setScreenWidth] = useState(window.innerWidth);
  const [showNavigation, __] = useState<boolean>(true);

  const livePads = launchpads?.filter(launchPad => {
    if (
      Date.now() < new Date(launchPad.endDate).getTime() &&
      ((launchPad.presaleDate &&
        Date.now() > new Date(launchPad.presaleDate).getTime()) ||
        Date.now() > new Date(launchPad.saleDate).getTime())
    ) {
      return launchPad;
    }
  });

  useEffect(() => {
    const changeWidth = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', changeWidth);

    return () => {
      window.removeEventListener('resize', changeWidth);
    };
  }, []);

  const upcomingPads = launchpads?.filter(launchPad => {
    if (
      (launchPad.presaleDate &&
        Date.now() < new Date(launchPad.presaleDate).getTime()) ||
      (!launchPad.presaleDate &&
        Date.now() < new Date(launchPad.saleDate).getTime())
    ) {
      return launchPad;
    }
  });
  const closedPads = launchpads?.filter(launchPad => {
    if (Date.now() > new Date(launchPad.endDate).getTime()) {
      return launchPad;
    }
  });

  const showSlides = (section: string) => {
    let isLoop;
    switch (section) {
      case 'live':
        isLoop = livePads && livePads.length >= 4 ? true : false;
        break;
      case 'upcoming':
        isLoop = upcomingPads && upcomingPads.length >= 4 ? true : false;
        break;
      case 'closed':
        isLoop = closedPads && closedPads.length >= 4 ? true : false;
        break;
      default:
        isLoop = false;
        break;
    }
    return (
      <Swiper
        navigation={showNavigation}
        loop={isLoop}
        freeMode={true}
        freeModeMinimumVelocity={0.4}
        freeModeMomentum={true}
        style={{ maxHeight: 'unset' }}
        direction="horizontal"
        grabCursor={true}
        preventClicksPropagation={true}
        preventClicks={true}
        initialSlide={1}
        className={styles.swiperContainer}
        breakpoints={{
          200: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          500: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          700: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          840: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          1050: {
            slidesPerView: 3,
            spaceBetween: 26,
          },
          1340: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
        }}
      >
        {section === 'live' &&
          livePads
            ?.map(live => {
              return live.collection ? (
                <SwiperSlide
                  style={{ height: 'auto' }}
                  className={`h-auto`}
                  key={`live${live.id}`}
                >
                  <CollectionCard collectionData={live.collection} />
                </SwiperSlide>
              ) : null;
            })
            .filter(Boolean)}
        {section === 'upcoming' &&
          upcomingPads
            ?.map(upcoming => {
              return upcoming.collection ? (
                <SwiperSlide
                  style={{ height: 'auto' }}
                  className={`h-auto`}
                  key={`upcoming${upcoming.id}`}
                >
                  <CollectionCard collectionData={upcoming.collection} />
                </SwiperSlide>
              ) : null;
            })
            .filter(Boolean)}
        {section === 'closed' &&
          closedPads
            ?.map(closed => {
              return closed.collection ? (
                <SwiperSlide
                  style={{ height: 'auto' }}
                  className={`h-auto`}
                  key={`closed${closed.id}`}
                >
                  <CollectionCard collectionData={closed.collection} />
                </SwiperSlide>
              ) : null;
            })
            .filter(Boolean)}
      </Swiper>
    );
  };

  return (
    <div className="flex flex-wrap gap-20">
      {livePads && livePads.length > 0 && (
        <div className="w-full flex flex-col justify-center sm:justify-start items-center sm:items-start">
          <div
            className={`${styles.sectionHeader} fontVanguard font-bold w-1/2 sm:w-8/12 px-3 sm:px-0 pb-10`}
          >
            Live
          </div>
          <div className="flex items-top xl:justify-start justify-start sm:justify-center gap-4 w-full">
            {showSlides('live')}
          </div>
        </div>
      )}
      {upcomingPads && upcomingPads.length > 0 && (
        <div className="w-full flex flex-col justify-center sm:justify-start items-center sm:items-start">
          <div
            className={`${styles.sectionHeader} fontVanguard font-bold w-1/2 sm:w-8/12 px-3 sm:px-0 pb-10`}
          >
            Upcoming
          </div>
          <div className="flex flex-wrap items-top xl:justify-start justify-center w-full">
            {showSlides('upcoming')}
          </div>
        </div>
      )}
      {closedPads && closedPads.length > 0 && (
        <div className="w-full flex flex-col justify-center sm:justify-start items-center sm:items-start">
          <div
            className={`${styles.sectionHeader} fontVanguard font-bold w-1/2 sm:w-8/12 px-3 sm:px-0 pb-10`}
          >
            Closed
          </div>
          <div className="flex flex-wrap items-top xl:justify-start justify-center w-full">
            {showSlides('closed')}
          </div>
        </div>
      )}
    </div>
  );
};
